module.exports = __webpack_public_path__ + "static/media/ico_auteur_noborder.f3960f25.svg";